<template>
  <div class="mul-time-container" v-if="show">
    <hi-dialog class="mul-dialog" title="Repeat" @close="closeDialog">
      <div class="main-container">
        <div
          class="menu-item"
          @click="itemClick(item)"
          v-for="item in weeks"
          :key="item.key"
        >
          <div class="text">{{ item.text }}</div>
          <div class="select" v-if="item.select"></div>
        </div>
      </div>
      <div class="bottom-container">
        <hi-button type="primary" style="padding: 9px 28px" @click="done"
          >Done</hi-button
        >
      </div>
    </hi-dialog>
  </div>
</template>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import { weekType } from "../../../const/setting";
import hiButton from "../../../components/button/Index";
import _ from "lodash";

export default {
  name: "MulSelectorComponent",
  components: { hiDialog, hiButton },
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    model: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: [],
      show: false,
    };
  },
  methods: {
    closeDialog() {
      this.show = false;
    },
    itemClick(item) {
      // 是否已经选中
      const index = this.value.findIndex((v) => v === item.key);
      // 没选则进行选中
      if (index === -1) {
        this.value.push(item.key);
      } else {
        // 选中则反选去掉
        this.value.splice(index, 1);
      }
      // 保持至少有一个勾选
      if (this.value.length === 0) {
        this.value.push(item.key);
      }
    },
    done() {
      this.$emit("updateValue", this.value);
      this.closeDialog();
    },
  },
  computed: {
    weeks() {
      return weekType.map((w) => {
        return {
          ...w,
          select: this.value.findIndex((v) => v === w.key) !== -1,
        };
      });
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.value = _.cloneDeep(this.model);
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/style/theme.less";

.mul-time-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .mul-dialog {
    width: 375px;
    background: white;
    height: 700px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    .main-container {
      flex: 1;
      .menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        border-bottom: solid 1px #e6e6e6;
        padding: 0 25px;
        cursor: pointer;
        :hover,
        :active {
          opacity: 0.7;
        }
        .text {
          font-size: 16px;
        }
        .select {
          width: 16px;
          height: 16px;
          background-size: contain;
          background-image: url("../../../../public/images/setting/select_2@3x.png");
        }
      }
    }
    .bottom-container {
      height: 64px;
      border-top: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 20px;
    }
  }
}
</style>
